import { Key } from 'react';
import { Collapse, Box } from '@mui/material';
import { NavItem } from '../navItem';
import { NavSubItem } from '../navSubItem';
import { NavItemListProps, NavSubItemProps } from '../../types';
import { useSubNavigation } from '../../hooks';
import { useAuthentication } from 'src/features/authentication/context';
import { CREATE_DASHBOARD, PREVIEW_DASHBOARD } from 'src/routes/config';
import { PlusFillIcon } from 'src/assets/icons/PlusFillIcon';
import { scrollbarOverride } from 'src/styles';
import { styled } from '@mui/material/styles';
import { useAllDashboardsContext } from 'src/contexts/allDashboardsContext/allDashboards.context';
import { ACCESS_ROLES } from 'src/config';
import { useResponsive } from 'src/hooks/useResponsive';

export const NavList = ({
  isToggle,
  isActive,
  onClickHandler,
  title,
  path,
  icon,
  testId,
  subItems,
  additionalLabel,
  handleCloseSideBar,
  additionalLabelState,
}: NavItemListProps) => {
  const {
    customerId: { value: customerId },
    getCurrentRole,
  } = useAuthentication();

  const StyledBox = styled(Box)(scrollbarOverride);

  const { dashboards } = useAllDashboardsContext({
    title: title,
    isActive: isActive,
  });

  const navigationDashboards = dashboards?.map((item: any) => ({
    path: `${PREVIEW_DASHBOARD}/${item.dashboardId}`,
    title: item.title,
    testId: `preview-${item.title}`,
    dashboardId: item.dashboardId,
  }));

  const isAccountAdmin = getCurrentRole(customerId, null) === ACCESS_ROLES.ACCOUNT_ADMIN;
  const isSuperAdmin = getCurrentRole(customerId, null) === ACCESS_ROLES.SUPER_ADMIN;

  const isMobile = useResponsive('down', 'md');

  const dashboardsSubItems = [
    ...navigationDashboards,
    ...(!isMobile && (isAccountAdmin || isSuperAdmin)
      ? [
          {
            path: CREATE_DASHBOARD,
            title: 'Create new Dashboard',
            testId: 'create-dashboard-button',
            icon: <PlusFillIcon fill="#ffffff" />,
          },
        ]
      : []),
  ];

  const effectiveSubItems = title === 'Dashboards' ? dashboardsSubItems : subItems;
  const { subItemsActive, onSubitemClickHandler } = useSubNavigation(effectiveSubItems!);

  const findIsSubNavItemActive = (path: string) => {
    if (effectiveSubItems && subItemsActive)
      return subItemsActive.find((item: { path: string }) => item.path === path)?.isActive;
  };
  return (
    <>
      <NavItem
        isActive={isActive}
        onClickHandler={onClickHandler}
        path={path}
        title={title}
        icon={icon}
        testId={testId}
        subItems={effectiveSubItems}
        toggleState={isToggle}
        additionalLabel={additionalLabel}
        handleCloseSideBar={handleCloseSideBar}
        isSuperAdmin={isSuperAdmin}
        additionalLabelState={additionalLabelState}
      />
      {effectiveSubItems && effectiveSubItems.length > 0 ? (
        <Collapse in={isToggle && isActive} unmountOnExit>
          <StyledBox
            sx={{
              maxHeight: 4 * 48,
              overflowY: effectiveSubItems.length > 4 ? 'auto' : 'visible',
              p: 1,
            }}
          >
            {effectiveSubItems?.map(({ path, title, testId, icon }: NavSubItemProps, i: Key) => (
              <NavSubItem
                key={i}
                path={path}
                title={title}
                testId={testId}
                isActive={findIsSubNavItemActive(path)}
                onClick={onSubitemClickHandler}
                handleCloseSideBar={handleCloseSideBar}
                icon={icon}
              />
            ))}
          </StyledBox>
        </Collapse>
      ) : null}
    </>
  );
};
